import React, { useState, useEffect } from 'react';  
import { Link, useNavigate } from 'react-router-dom';
import Header from "../Component/Header";
import { postTransferCertificate } from '../Service/Api'; 
const Tc = () => {
  useEffect(() => {
    document.title = 'Transfer Certificate -  The Air Force School Subroto Park ';  
}, []);  
const [admission, setAdmission] = useState("");
const [name, setName] = useState("");
const [error, setError] = useState("");
const [loading, setLoading] = useState(false);
const handleAdmissionNoChange = (event) => {
  setAdmission(event.target.value);
  setError(""); // Clear error on user input
};

const handleFullNameChange = (event) => {
  setName(event.target.value);
  setError(""); // Clear error on user input
};

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!name || !admission) {
    setError("Please fill in all fields");
    return;
  }

  setLoading(true);
  try {
    const response = await postTransferCertificate(name, admission);

    if (response && response.data) {
      const filePath = response.data;

      // Declare fileUrl at the beginning of this block
      const fileUrl = `https://webapi.entab.info/api/image/${filePath}`;
      
      const fetchResponse = await fetch(fileUrl);

      if (!fetchResponse.ok) {
        throw new Error(`Failed to fetch the file. Status: ${fetchResponse.status}`);
      }

      const contentType = fetchResponse.headers.get('Content-Type');
     

      let fileType = 'unknown';
      if (contentType) {
        if (contentType.includes('pdf')) fileType = 'pdf';
        else if (contentType.includes('image')) fileType = 'image';
      }

      if (fileType === 'unknown') {
        // Fallback to extension-based detection
        const fileExtension = fileUrl.split('.').pop().toLowerCase();
        if (fileExtension === 'pdf') fileType = 'pdf';
        else if (['jpg', 'jpeg', 'png'].includes(fileExtension)) fileType = 'image';
      }

      if (fileType === 'unknown') {
        throw new Error('Unsupported file type received');
      }

      const blob = await fetchResponse.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileType === 'pdf' ? 'tc.pdf' : 'tc.jpg';

      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      setError('Invalid response from the server.');
    }
  } catch (error) {
    console.error('Error during file download:', error);
    setError(error.message || 'Failed to process your request. Please try again later.');
  } finally {
    setLoading(false);
  }
};
  return (
     <>
       
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                 
                 <li>Transfer Certificate</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Transfer Certificate</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12">
                          {/*  <div className="tcblock">
                        <div className="tc">
                            <form onSubmit={handleSubmit} >
                            <div>
                                <div className="formfil">
                                    <div className="form-group">
                                    <label for="number"><p> Admission No. </p></label>
                                    <input type="text" className="form-control" value={name} onChange={handleFullNameChange} />
                                    </div>
                                    <div className="form-group">
                                    <label for="number"><p> Student Full Name </p></label>
                                    <input type="text" className="form-control"  value={admission} onChange={handleAdmissionNoChange}/>
                                    </div>
                                </div>
                
                                <div className="clr30"></div>
                            <input type="submit" className="viewdetailsbtn"  value="Submit" />
                            </div>
                            {error && <p className="error">{error}</p>}
                            </form>
                        </div>
                       <iframe src='https://webapi.entab.info/api/image/TAFS/public/pdf/TC-Sample.pdf#toolbar=0' width="100%" height="300"></iframe>
                     </div> */}
                     <div className="tcdiv">
                     <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/wcp-2405291257-0873132259-1.pdf" target="_blank">Transfer Certificate Format (New)</Link></div>
                     <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_15.pdf" target="_blank">Transfer Certificate Format (Old)</Link></div>  
                     <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/tc-apr-2025.pdf" target="_blank">Click here to view - TC LIST FROM 24 apr 20 TO 24 apr 25 </Link></div> 
                     <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/tc25-MAR-2025.pdf" target="_blank">Click here to view - TC LIST  From 25 MAR 25 to 21 Apr 25 </Link></div> 

                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/bny-wcp-2409141418-1120980121-1.pdf" target="_blank">Click here to view - TC LIST</Link></div> 
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/wcp-2405291236-0867250765-1.pdf" target="_blank">Click here to view - TC LIST AS ON 29 MAY 2024</Link></div> 
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/wcp-2406071446-0160054585-1.pdf" target="_blank">Manleen Kaur</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/wcp-2404190906-1785712102-1.pdf" target="_blank">Click here to view - TC LIST AS ON 19 APRIL 2024</Link></div> 
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/wcp-2306011304-1114332361-1.pdf" target="_blank">Click here to view - TC LIST : 01 APRIL TO 31 MAY 2023</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/wcp-2304241225-0361355587-1.pdf" target="_blank">Click here to view - TC LIST AS ON 31 MAR 2023</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_50.pdf?sAb4j" target="_blank">Click here to view - TC LIST AS ON 21 JAN 2023</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_49.pdf?3Hqyi" target="_blank">Click here to view - TC LIST AS ON 31 OCT 2022</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_48.pdf?i2VFH" target="_blank">Click here to view - TC LIST AS ON 08 SEP 2022</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_47.pdf?hdvId" target="_blank">Click here to view - TC LIST AS ON 12 JUL 2022</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_46.pdf?ydJZM" target="_blank">Click here to view - TC LIST AS ON 18 APR 2022</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_45.pdf?4vzjH" target="_blank">Click here to view - TC LIST AS ON 04 APR 2022</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_44.pdf?1hWu6" target="_blank">Click here to view - TC LIST AS ON 18 NOV 2021</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_43.pdf?yVtNp" target="_blank">Click here to view - TC LIST AS ON 16 SEP 2021</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_42.pdf?GuJaS" target="_blank">Click here to view - TC LIST AS ON 16 JULY 2021</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_41.pdf?NK9eU" target="_blank">Click here to view - TC LIST AS ON JUNE 2021</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_40.pdf?lBtFS" target="_blank">Click here to view - TC LIST AS ON 10 MAY 2021</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_39.pdf?JmpSK" target="_blank">Click here to view - TC LIST AS ON 09 APR 2021</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_35.pdf?mf4IZ" target="_blank">Click here to view - TC LIST AS ON 21 AUG 2020 </Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_34.pdf?ufQPX" target="_blank">AYUSH SINGH</Link></div>   
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_37.pdf?gTqoF" target="_blank">SAMRATH SINGH BAJWA</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_36.pdf?whhi0" target="_blank">Click here to view - TC LIST AS ON 17 NOV 2020</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_38.pdf?fH4d8" target="_blank">Click here to view - TC LIST AS ON 27 JAN 2021</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_26.pdf?7RYTu" target="_blank">Click here to view - TC LIST AS ON 15 APR 2019 </Link></div>     
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_27.pdf?LcsbH" target="_blank">ISHITA SINGH</Link></div>    
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_28.pdf?61TFe" target="_blank">ARNAV SINGH</Link></div>   
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_29.pdf?anCsu" target="_blank">ANSHUMAN SINGH SHEKHAWAT</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_30.pdf?eny2b" target="_blank">Click here to view - TC LIST FROM 16 APR 19 TO 15 JUL 19</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_31.pdf?9iduN" target="_blank">Click here to view - TC LIST FROM 16 JUL 19 TO 31 JUL 19</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_32.pdf?iQtZk" target="_blank">Click here to view - TC LIST FROM 01 AUG 19 TO 26 SEP 19</Link></div>
                      <div><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Tc/contentpage_105_113_33.pdf?C9cyf" target="_blank">Click here to view - TC LIST FROM 27 SEP 19 TO 31 OCT 19</Link></div> 
                      </div>
                     </div>
                </div>
            </div>
         </div>
         
     </>
  )
}

export default Tc

